<div mat-dialog-actions>
  <aside><ng-content select="[la-dialog-footer-left]"></ng-content></aside>
  <ng-content select="[la-dialog-footer-right]"></ng-content>
</div>
